import { useEffect, useState, useRef } from 'react';
import PageApp from '../../../Page';
import { HomeOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { Button, Form, Row, Col, Select, DatePicker, Space, message } from 'antd';
import { downloadTxt } from '../../../../apis/DistribucionBancariaApi';
import { getAll as getFormatoBancario } from '../../../../apis/DefinicionFormatoBancoApi';
import AnioPeriodo from '../../../../components/forms/anio_periodo';
import dayjs from 'dayjs';

const { Option } = Select;

const routes = [{
  href: '',
  title: <>
    <HomeOutlined />
    <span>Inicio</span>
  </>,
}, {
  href: '',
  title: (
    <>
      <UnorderedListOutlined />
      <span>Catálogos</span>
    </>
  ),
}, {
  href: '',
  title: (
    <>
      <UnorderedListOutlined />
      <span>Distribucion Bancaria</span>
    </>
  ),
}];

const DistribucionBancaria = () => {
  const [form] = Form.useForm();
  const [ID, setID] = useState(0);
  const [loading, setLoading] = useState(true);
  const [registrosPatronales, setRegistrosPatronales] = useState([]);
  const [initialValues, setInitialValues] = useState(null);
  const [modified, setModified] = useState(false);
  const [header, setHeader] = useState(null);
  const [period, setPeriod] = useState(null);
  const [disabledForm, setDisabled] = useState(true);

  // Get first and last day of current month
  const getFirstAndLastDayOfMonth = () => {
    const firstDay = dayjs().startOf('month');
    const lastDay = dayjs().endOf('month');
    return { firstDay, lastDay };
  };

  const handleSave = async () => {
    try {
      debugger;
      await form.validateFields();
      
      const values = form.getFieldsValue();
      
      if (!header?.periodo_id || !header?.anio || !header?.num_periodo) {
        message.error('Por favor, selecciona un período válido');
        return;
      }  
      await downloadTxt(
        header.periodo_id,
        values.formato_bancario_id, 
        header.anio,              
        header.num_periodo           
      );
      
      message.success('Descarga iniciada correctamente');
    } catch (error) {
      console.error('Error:', error);
      message.error('Por favor, verifica los campos del formulario');
    }
  };
  
  const resetForm = () => {
    const { firstDay, lastDay } = getFirstAndLastDayOfMonth();
    form.resetFields();
    form.setFieldsValue({
      activo: true,
      fecha_inicial: firstDay,
      fecha_final: lastDay
    });
    setID(0);
  };

  const getListRegistrosPatronales = async () => {
    const response = await getFormatoBancario();
    if (response.ok) {
      let items = response.payload;
      setRegistrosPatronales(items);
    }
  };

  const onBlurHeader = async (values, period) => {
    setHeader(values)
    if (values?.anio && values?.num_periodo && values?.periodo_id) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }

    if (period) {
      setPeriod(period);
    } else {
      setPeriod(null)
    }
  }

  const effectRan = useRef(false);
  useEffect(() => {
    if (!effectRan.current) {
      (async () => {
        await getListRegistrosPatronales();
        
        const { firstDay, lastDay } = getFirstAndLastDayOfMonth();
        
        setInitialValues({
          activo: true
        });

        setTimeout(() => {
          form.setFieldsValue({
            fecha_inicial: firstDay,
            fecha_final: lastDay
          });
        }, 0);
        
        setLoading(false);
      })();
    }
    return () => effectRan.current = true;
  }, [form]);

  return <PageApp
    routes={routes}
    title={'Distribucion Bancaria'}
    cardTitle='Formulario de Distribucion Bancaria'>
    {
      loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <AnioPeriodo onBlur={onBlurHeader} form={form} disabledForm={false} />
          <br />
          
          {initialValues && !disabledForm && (
            <Form
              layout="vertical"
              form={form}
              requiredMark
              autoComplete="off"
              initialValues={initialValues}
              onFinish={handleSave}>
              <Row gutter={16}>
                <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                  <Form.Item
                    name="formato_bancario_id"
                    label="Formato Bancario"
                    rules={[
                      {
                        required: true,
                        message: 'Selecciona un formato bancario',
                      },
                    ]}
                  >
                    <Select placeholder="Por favor selecciona una opción">
                      {
                        registrosPatronales.map((item) => <Option key={item.id} value={item.id}>{item.formato}</Option>)
                      }
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Space>
                    <Button type="primary" htmlType="submit">
                      Descargar
                    </Button>
                  </Space>
                </Col>
              </Row>
            </Form>
          )}
        </>
      )
    }
  </PageApp>
};

export default DistribucionBancaria;